import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from "./state/store";
import i18n from "./i18n";
import BootstrapVueNext from 'bootstrap-vue-next';
import VueApexCharts from "vue3-apexcharts";

// Packages CSS import
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'simplebar-vue/dist/simplebar.min.css';

import '@/assets/scss/style.scss';
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";

// Noverand default visual identity
document.body.setAttribute('data-pc-theme', 'light');
document.body.setAttribute('data-pc-sidebar-theme', 'dark');
document.body.setAttribute('data-pc-preset', 'preset-1');

// bootstrap.bundle.js
import 'bootstrap/dist/js/bootstrap.bundle.js';

createApp(App)
.use(store)
.use(router)
.use(i18n)
.use(BootstrapVueNext)
.use(VueApexCharts)
.use(Toast, {position:POSITION.TOP_RIGHT,timeout:2200,closeOnClick:true,pauseOnHover:true,draggable:true})
.mount('#app')
